import { useSelector } from "react-redux";
import { ProtectedRoutes } from "./ProtectedRoutes";
import { PublicRoutes } from "./PublicRoutes";

export const Routing = () => {
  // const isAuthenticated = useSelector(
  //   (state) => state.login.login.isAuthenticated
  // );

 const isAuthenticated = useSelector(
  (state) => state.login.login.isAuthenticated
);

return <>{isAuthenticated ? <ProtectedRoutes /> : <PublicRoutes />}</>;
};
    